import BaseContainer from '@commons/containers/BaseContainer';
import type { DrupalSection } from '@commons/types/drupal';

/**
 * Blank section component.
 *
 * Automatically added by Drupal whenever there's no section on the page.
 */

const BlankSection = ({}: DrupalSection) => {
  return <BaseContainer width={12} padding="md" />;
};

export default BlankSection;
